'use client';

import { RowCard } from '@/components/ui/data-display/cards/RowCard';

export const MiniCardItem = ({ data }) => {
  const imagePrefix = '';
  return (
    <RowCard
      data={{
        title: data?.fields?.title,
        alt_img: data?.fields?.alt_img,
        label: data?.fields?.label,
        placeholder: data?.fields?.placeholder,
        img_mini_card: data?.fields?.img_mini_card
          ? imagePrefix + data?.fields?.img_mini_card
          : undefined,
      }}
    />
  );
};
